



















































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import App from '../App.vue'
import axios from 'axios'
import { ProductData } from '../models/ProductData'
import ErrorDialog from './ErrorDialog.vue'
import ApplicationDialog from './ApplicationDialog.vue'
import CommandDialog from './CommandDialog.vue'
import RowActions from './RowActions.vue'
import ActionsCard from './ActionsCard.vue'
import { EnumHelpers, ProductOrToolType, LicensingType } from '../helpers/EnumHelpers'
import { ErrorHandlingHelpers } from '../helpers/ErrorHandlingHelpers'
import { FailureResponseData } from '../models/FailureResponseData'
import ValidationErrorsCard from './ValidationErrorsCard.vue'
import TitleCard from './TitleCard.vue'

@Component({
  components: {
    RowActions,
    ErrorDialog,
    ApplicationDialog,
    CommandDialog,
    ValidationErrorsCard,
    TitleCard,
    ActionsCard,
  },
})
export default class ProductDialog extends App {
  private get getTitle() {
    if (this.isValidEdit()) {
      return 'Edit ' + this.item.name
    } else {
      return 'Create New Product'
    }
  }
  private get getApplicationHeaders() {
    if (this.$auth.canManage) {
      return this.applicationHeaders
    } else {
      return this.applicationHeaders.filter((h) => h.text !== 'Actions')
    }
  }
  private get getCommandHeaders() {
    if (this.$auth.canManage) {
      return this.commandHeaders
    } else {
      return this.commandHeaders.filter((h) => h.text !== 'Actions')
    }
  }

  @Prop({ default: false })
  public isShown!: boolean
  @Prop({ default: false })
  public isEdit!: boolean
  @Prop({ required: false })
  public item!: ProductData

  private privateIsShown: boolean = false
  private errorDialogIsShown: boolean = false
  private failure: FailureResponseData = new FailureResponseData()

  private types: Array<string> = EnumHelpers.GetProductOrToolTypes()

  private name: string = ''
  private iconFileName: string = ''
  private selectedTypes: Array<string> = []
  private description: string = ''
  private helpFilePath: string = ''
  private commonFolder: string = ''
  private panelName: string = ''
  private licensingName: string = ''
  private displayUpdateNotification: boolean = false
  private downloadPageUrl: string = ''
  private hidden: boolean = false

  @Watch('isShown')
  public onIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    this.privateIsShown = value
  }
  @Watch('privateIsShown')
  public onprivateIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    if (value) {
      this.fetchProduct()
    } else {
      this.$emit('dialogClosed')
      this.loading = true
    }
  }

  public async commitChanges() {
    if (!this.checkForm()) {
      return
    }

    this.loading = true

    try {
      let resp
      const res: ProductData = new ProductData(
        this.name,
        this.iconFileName,
        EnumHelpers.GetFlaggedProductOrToolTypeValue(this.selectedTypes),
        this.panelName,
        this.helpFilePath,
        this.description,
        this.commonFolder,
        this.licensingName,
        '',
        [],
        this.displayUpdateNotification,
        this.downloadPageUrl,
        this.hidden
      )

      let errorObject: FailureResponseData = new FailureResponseData()
      let errorsOccurred: boolean = false

      if (this.isValidEdit()) {
        resp = await axios.put<ProductData>(`Products/${this.item.id}`, res).catch((error) => {
          errorsOccurred = true
          errorObject = ErrorHandlingHelpers.getFailureMessage(error)
        })
      } else {
        resp = await axios.post<ProductData>(`Products`, res).catch((error) => {
          errorsOccurred = true
          errorObject = ErrorHandlingHelpers.getFailureMessage(error)
        })
      }

      if (errorsOccurred) {
        this.failure = errorObject
        this.errorDialogIsShown = true
      } else {
        if (this.isValidEdit()) {
          this.$emit('editProduct', this.item, resp.data)
        } else {
          this.$emit('addProduct', resp.data)
        }
        this.privateIsShown = false
      }
    } catch (e) {
      this.failure = new FailureResponseData(e.message)
      this.errorDialogIsShown = true
    }

    this.loading = false
  }

  public cancelled(item) {
    this.privateIsShown = false
    this.$emit('dialogCancelled')
  }

  private setDefaultData() {
    this.validationErrors = []
    this.name = ''
    this.iconFileName = ''
    this.selectedTypes = []
    this.usageType = 'Other'
    this.description = ''
    this.helpFilePath = ''
    this.panelName = ''
    this.commonFolder = ''
    this.licensingName = ''
    this.displayUpdateNotification = false
    this.downloadPageUrl = ''
    this.hidden = false

    this.resetValidation()
  }
  private getType(type: number) {
    return EnumHelpers.GetCommandType(type)
  }

  private getColor(type: number) {
    return EnumHelpers.GetColor(type)
  }

  private isValidEdit() {
    return this.isEdit && this.item !== undefined
  }

  private checkForm() {
    this.validationErrors = []

    const form: any = this.$refs.form
    if (form) {
      return form.validate()
    } else {
      if (!this.name) {
        this.validationErrors.push('Name is required.')
      }
      if (this.selectedTypes.length === 0) {
        this.validationErrors.push('At least one type is required.')
      }
      if (!this.iconFileName) {
        this.validationErrors.push('Icon file name is required.')
      }
      if (!this.helpFilePath) {
        this.validationErrors.push('Help file path is required.')
      }
      if (!this.panelName) {
        this.validationErrors.push('Panel name is required.')
      }
      if (!this.licensingName) {
        this.validationErrors.push('Licensing name is required.')
      }
      if (!this.commonFolder) {
        this.validationErrors.push('Common folder is required.')
      }
      if (!this.description) {
        this.validationErrors.push('Description is required.')
      }
      return this.validationErrors.length === 0
    }
  }

  private async fetchProduct() {
    try {
      this.setDefaultData()
      if (this.isValidEdit()) {
        const resp = await axios.get<ProductData>(`Products/${this.item.id}`)

        this.name = resp.data.name
        this.iconFileName = resp.data.iconFileName
        this.selectedTypes = EnumHelpers.GetFlaggedProductOrToolTypes(resp.data.type, false)
        this.helpFilePath = resp.data.helpFilePath
        this.description = resp.data.description
        this.commonFolder = resp.data.commonFolder
        this.panelName = resp.data.panelName
        this.licensingName = resp.data.licensingName
        this.displayUpdateNotification = resp.data.displayUpdateNotification
        this.hidden = resp.data.hidden
        this.downloadPageUrl = resp.data.downloadPageUrl
      }
      // this.items = resp.data.items;
    } catch (e) {
      this.showError = true
      this.errorMessage = `Error while loading tool data: ${e.message}.`
    }
    this.loading = false
  }
}
